/**
 * This package's translations, registered at import.
 *
 * One namespace for both audiences. The vocabulary is accounting's and it has
 * to be the same on both sides: what the ADV's ledger calls "reste à payer" is
 * the figure the customer reads on their own statement, and a customer
 * phoning about it quotes the words on their screen. Two bundles would drift,
 * and the drift would land in that phone call.
 */

import { registerNamespace } from "@hardauto/core-i18n";

import en from "./locales/en.json";
import fr from "./locales/fr.json";

export const NAMESPACE = "billing";

registerNamespace(NAMESPACE, { en, fr });
